import { Users } from 'lucide-react';

import { page, type DeclarationModule } from '@/app/moduleRegistry';

/**
 * Declaration du module Clients.
 *
 * `id` doit correspondre EXACTEMENT a la cle du back (`ClientsModule.CleModule`) :
 * c'est sur cette chaine que se fait le rapprochement avec `ModuleActivation`.
 *
 * Les pages sont chargees paresseusement : tant que l'utilisateur ne visite pas
 * Clients, son code ne fait pas partie du bundle telecharge (§7).
 */
export const moduleClients: DeclarationModule = {
  id: 'clients',
  libelle: 'Clients',
  icone: Users,
  ordre: 10,

  routes: [
    {
      chemin: 'clients',
      estAccueil: true,
      composant: page(() => import('./pages/ListeClientsPage')),
    },
    {
      chemin: 'clients/nouveau',
      roleRequis: 'Membre',
      composant: page(async () => ({
        default: (await import('./pages/FicheClientPage')).NouveauClientPage,
      })),
    },
    {
      chemin: 'clients/:clientId',
      composant: page(() => import('./pages/FicheClientPage')),
    },
  ],
};
